import { AbstractModel } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ClaimAnalysisResultModel } from '../claim-analysis-result-model';
import type { ClaimAnalysisResponse } from '../../types/claim-analysis';

/**
 * 创建初始的权利要求分析结果数据
 *
 * @returns 初始化的 ClaimAnalysisResponse 对象
 */
function createInitialClaimAnalysisResult(): ClaimAnalysisResponse {
    return {
        taskId: '',
        conclusiveOpinionId: '',
        conclusiveOpinionTitle: '',
        results: [],
        totalClaims: 0,
    };
}

/**
 * 权利要求分析结果模型实现
 *
 * 管理 OAR 任务中权利要求分析的结果数据，包括：
 * - 任务和结论性意见标识信息
 * - 权利要求分析结果列表
 * - 分析统计信息
 */
@injectable()
export class ClaimAnalysisResultModelImpl
    extends AbstractModel<ClaimAnalysisResponse>
    implements ClaimAnalysisResultModel
{
    protected _modelData: ClaimAnalysisResponse = createInitialClaimAnalysisResult();

    /**
     * 克隆数据
     *
     * @param data - 要克隆的数据
     * @returns 克隆后的数据
     */
    clone(data: ClaimAnalysisResponse): ClaimAnalysisResponse {
        return {
            ...data,
            // 深拷贝 results 数组
            results: data.results.map((result) => ({ ...result })),
        };
    }

    /**
     * 释放资源
     *
     * 清空所有权利要求分析结果数据，恢复到初始状态
     */
    dispose(): void {
        this.update(() => createInitialClaimAnalysisResult());
    }
}
